import {
  AnchorButton,
  Button,
  Card,
  Collapse,
  ControlGroup,
  Elevation,
  Tag,
} from "@blueprintjs/core";
import React from "react";
import { apiCallPost } from "../fns/util";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import { withRouter } from "react-router";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";
import cogoToast from "cogo-toast";
import AsyncSelWrap from "../utils/AsyncSelWrap";

class KeyPeople extends React.Component {
  state = {
    collapsed: true,
    userSearching: false,
    userSearchResults: [],
    userSelected: null,
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }
  roles = [
    "Admission",
    "Block Room Prep Assistant",
    "Anaesthesia Assistant",
    "OT Prep Assistant",
    "Consumable/Implant Prep Assistant",
    "Sterilization",
    "Floor Assistant",
    "Follow-Up & Explanation",
    "Discharge",
    "Patient Medication",
  ];
  search = async (
    string,
    searchResArray,
    isSearchingShowSpinner,
    selectedItem,
    apiUrl
  ) => {
    if (!string) {
      this.setState({
        [searchResArray]: [],
        [selectedItem]: null,
      });
      return;
    }
    try {
      this.setState({ [isSearchingShowSpinner]: true });
      let payload = { prefix: string || "" };
      let res = await apiCallPost(apiUrl, payload);
      this.setState({
        [searchResArray]: res,
        [isSearchingShowSpinner]: false,
      });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details."
      );
      console.log(err);
    }
  };
  renderAsyncSearchers = (
    tagText,
    placeHolderText,
    stateSearchingKey,
    stateSearchResultsKey,
    stateSelectedItemKey,
    searchApiUrl,
    handleAddUser
  ) => {
    return (
      <ControlGroup>
        <Tag large minimal>
          {tagText}
        </Tag>
        <AsyncSelWrap
          disabled={this.props.isBusy || this.state.isWaitingOnLineItem}
          placeholder={placeHolderText}
          searching={this.state[stateSearchingKey]}
          items={this.state[stateSearchResultsKey].map((each) => {
            return {
              ...each,
              item: each.name,
              entityTypeString: each.email,
              helper: each._id,
            };
          })}
          selectedItem={null}
          update={(string) =>
            this.search(
              string,
              stateSearchResultsKey,
              stateSearchingKey,
              stateSelectedItemKey,
              searchApiUrl
            )
          }
          onChange={(chosenItem) => {
            this.setState({ [stateSelectedItemKey]: chosenItem }, () => {
              handleAddUser();
            });
          }}
        />
      </ControlGroup>
    );
  };
  renderAddNewPerson = () => {
    const handleAddUser = () => {
      if (!this.state.userSelected || !this.state.userSelected._id) {
        cogoToast.error("Please select a user");
        return;
      }
      if (!this.state.role) {
        cogoToast.error("Please select a role");
        return;
      }
      this.props.onUpdate({
        keyPeople: [
          ...this.props.data.keyPeople,
          {
            userName: this.state.userSelected.name,
            userId: this.state.userSelected._id,
            role: this.state.role,
          },
        ],
      });
      this.setState({
        userSelected: null,
        role: null,
      });
    };

    return (
      <ControlGroup>
        <Tag intent="primary" large minimal>
          Add Personnel Role
        </Tag>
        <Tag intent="primary" large minimal>
          Role
        </Tag>
        <SingleSelectWrapper
          items={this.roles.filter((each) => {
            let idx = _.findIndex(
              this.props.data.keyPeople,
              (x) => x.role === each
            );
            return idx === -1;
          })}
          selectedValue={this.state.role}
          onChange={(value) => this.setState({ role: value })}
          showSelectProp={true}
        />{" "}
        {this.renderAsyncSearchers(
          "User",
          "Search User",
          "userSearching",
          "userSearchResults",
          "userSelected",
          `/users/${this.props.authStore.prefix}/search`,
          handleAddUser
        )}
        <Button icon="add" outlined onClick={handleAddUser} />
      </ControlGroup>
    );
  };
  renderKeyPeople = () => {
    return this.roles.map((each) => {
      let idx = _.findIndex(this.props.data.keyPeople, (x) => x.role === each);
      if (idx > -1) {
        return (
          <ControlGroup>
            <Tag
              large
              intent="success"
              minimal
              icon="endorsed"
              onRemove={() => {
                let ll = this.props.data.keyPeople;
                ll.splice(idx, 1);
                this.props.onUpdate({ keyPeople: ll });
              }}
            >
              {each}
            </Tag>
            <Tag large intent="primary" icon="person">
              {this.props.data.keyPeople[idx].userName}
            </Tag>
          </ControlGroup>
        );
      } else {
        return (
          <ControlGroup>
            <Tag minimal large intent="warning">
              {each}
            </Tag>
            <Tag large minimal>
              Not Chosen
            </Tag>
          </ControlGroup>
        );
      }
    });
  };
  renderBasedOnLifecycle = () => {
    return (
      <>
        <Collapse isOpen={this.state.collapsed}>
          {" "}
          <Card elevation={Elevation.FOUR}>
            <Tag large intent="primary" style={{ marginBottom: "10px" }}>
              Key People
            </Tag>
            <Button
              icon="double-chevron-down"
              outlined
              onClick={() => this.setState({ collapsed: false })}
            />
          </Card>
        </Collapse>{" "}
        <Collapse isOpen={!this.state.collapsed}>
          <Card elevation={Elevation.FOUR} className="dark__bg">
            <ControlGroup style={{ marginBottom: "10px" }}>
              <Tag large fill intent="primary">
                Key People
              </Tag>
              <Button
                icon="double-chevron-down"
                outlined
                onClick={() => this.setState({ collapsed: true })}
              />
            </ControlGroup>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <AnchorButton
                style={{ marginLeft: "5px" }}
                outlined
                target="_blank"
                icon="credit-card"
                href={`https://print.newchart.care/sx/bedHeadChecklist/${this.state._id}`}
              >
                Bed Head Ticket
              </AnchorButton>
              <AnchorButton
                style={{ marginLeft: "5px" }}
                outlined
                target="_blank"
                icon="credit-card"
                href={`https://print.newchart.care/sx/bedHeadChecklist/${this.state._id}`}
              >
                Safety Checklist
              </AnchorButton>
            </div>
            <div
              style={
                this.props.canEdit
                  ? {}
                  : {
                      "pointer-events": "none",
                      opacity: 0.5,
                    }
              }
            >
              {this.renderAddNewPerson()}
              <br /> <br />
              {this.renderKeyPeople()}
              <br />
            </div>
          </Card>
        </Collapse>
      </>
    );
  };
  render() {
    return <div>{this.renderBasedOnLifecycle()}</div>;
  }
}

export default inject("authStore")(observer(withRouter(KeyPeople)));
